import Container from "@components/Container/Container";
import { useWindowSize } from "@hooks/useWindowSize";

import EEFooterDesktop from "./EEFooterDesktop";
import EEFooterMobile from "./EEFooterMobile";

/**
 * Component to display footer in EE pages
 */
const EEFooter = (): React.ReactElement => {
  const { isScreenLG } = useWindowSize();

  return (
    <footer
      data-testid="ee-footer-component"
      className="mb-4 bg-gray-850 pb-7 pt-10 font-public-sans"
    >
      <Container rootClassName="flex flex-row justify-center text-white">
        {isScreenLG ? <EEFooterDesktop /> : <EEFooterMobile />}
      </Container>
    </footer>
  );
};

export default EEFooter;
